import CheckboxInputField from "ds_legacy/components/CheckboxInputField";
import { margin } from "ds_legacy/materials/metrics";
import {
  Section,
  SectionRow,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { FormWatcher } from "react-forms-state";
import { useTranslations } from "translations";

export const LegalRepresentationSection = () => {
  const translations = useTranslations();
  return (
    <Section
      title={
        translations.patientForms.transitionalCareForm.contactInformation
          .titleLegalRep
      }
    >
      <CheckboxInputField
        elementName="legal_representative_consent_provided"
        label={
          translations.patientForms.transitionalCareForm.contactInformation
            .confirmedWithLegalRep
        }
        labelStyleOverride={{ margin: margin(1, -1.375, 0) }}
        sideMutation={(value, mutate) => {
          if (!value) {
            mutate(null, "legal_representative_last_name");
            mutate(null, "legal_representative_first_name");
            mutate(null, "legal_representative_location_street");
            mutate(null, "legal_representative_location_street_number");
            mutate(null, "legal_representative_location_zipcode");
            mutate(null, "legal_representative_location_city");
          }
        }}
      />
      <FormWatcher watchPath="legal_representative_consent_provided">
        {({ watchedValue: confirmedWithLegalRep }) => {
          return (
            <>
              <SectionRow>
                <TextInputWithLabel
                  disabled={!confirmedWithLegalRep}
                  elementName="legal_representative_last_name"
                  isBold
                  isLarge
                  label={
                    translations.patientForms.transitionalCareForm
                      .contactInformation.legalRepName
                  }
                />
                <TextInputWithLabel
                  disabled={!confirmedWithLegalRep}
                  elementName="legal_representative_first_name"
                  isBold
                  isLarge
                  label={
                    translations.patientForms.transitionalCareForm
                      .contactInformation.legalRepFirstName
                  }
                />
              </SectionRow>
              <SectionRow>
                <TextInputWithLabel
                  disabled={!confirmedWithLegalRep}
                  elementName="legal_representative_location_street"
                  isBold
                  isLarge
                  label={
                    translations.patientForms.transitionalCareForm
                      .contactInformation.legalRepStreet
                  }
                />
                <TextInputWithLabel
                  disabled={!confirmedWithLegalRep}
                  elementName="legal_representative_location_street_number"
                  isBold
                  label={
                    translations.patientForms.transitionalCareForm
                      .contactInformation.legalRepStreetNumber
                  }
                />
                <TextInputWithLabel
                  disabled={!confirmedWithLegalRep}
                  elementName="legal_representative_location_zipcode"
                  isBold
                  label={
                    translations.patientForms.transitionalCareForm
                      .contactInformation.legalRepZipCode
                  }
                />
              </SectionRow>

              <SectionRow>
                <TextInputWithLabel
                  disabled={!confirmedWithLegalRep}
                  elementName="legal_representative_location_city"
                  isBold
                  isLarge
                  label={
                    translations.patientForms.transitionalCareForm
                      .contactInformation.legalRepCity
                  }
                />
              </SectionRow>
            </>
          );
        }}
      </FormWatcher>
    </Section>
  );
};
